import { render, staticRenderFns } from "./ServiceServiceSection.vue?vue&type=template&id=56d5ffdf&scoped=true"
import script from "./ServiceServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceServiceSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceServiceSection.vue?vue&type=style&index=0&id=56d5ffdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d5ffdf",
  null
  
)

export default component.exports